module.exports = __webpack_public_path__ + "static/sketch-fc3f2afc3e6ae89d0f0716e52404323d.png";